export const webClientId = '855577569501-2bplhil7pe2gveaaj5ic7566trmshk54.apps.googleusercontent.com'